<template>
    <div class="contents_wrap" style="min-height: calc(100% - 60px); display: flex; height: auto;">
        <section>
            <div class="login_wrap step2">
                <h3 class="call">{{this.$t('MSG_TXT_AICC_START_SIP_LABEL_1')}}</h3>
                <div class="box_gray">
                    <ul class="ulist">
                        <li>
                            <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_1')}}</strong>
                            <span>{{aiccInfo.contactCenterName}}</span>
                        </li>
                        <li>
                            <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_2')}}</strong>
                            <span>{{contactCenterUrl}}</span>
                        </li>
                        <li>
                            <strong>{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_3')}}</strong>
                            <span>{{aiccInfo.contactCenterPrice}}</span>
                        </li>
                    </ul>
                </div>
                <div class="tbl_info">
                    <div class="total">
                        {{this.$t('MSG_TXT_AICC_START_SIP_TABLE_TOTAL')}}<strong>{{items.length}}</strong>
                        <span v-if="selected.length > 0" style="margin-left:10px; color:#516AF4; ">{{selected.length}}개 선택됨</span>
                    </div>
                    <div class="btn_area">
                        <ur-button small @click="onClickRowAdd">{{this.$t('MSG_TXT_AICC_START_SIP_TABLE_ADD')}}</ur-button>
                        <ur-button small :disabled="selected.length < 1" @click="onClickRowDel">{{this.$t('MSG_TXT_AICC_START_SIP_TABLE_DEL')}}</ur-button>
                        <!--
                        <button :class="btnClass(false)" @click="onClickRowAdd">{{this.$t('MSG_TXT_AICC_START_SIP_TABLE_ADD')}}</button>
                        <button :disabled="selected.length < 1" :class="btnClass(selected.length < 1)" @click="onClickRowDel">{{this.$t('MSG_TXT_AICC_START_SIP_TABLE_DEL')}}</button>
                        -->
                    </div>
                </div>
                <div class="tbl_list">
                    <ur-table ref="table" multiSelect selectAll :headers="headers" :items="items" v-model="selected" noPage noControl @sort="onClickSort">
                        <template slot="items" slot-scope="props">
                            <td style="text-align: center;"><ur-checkbox small :checked="isRowSelected(props.item)" @click="onClickRow(props.item)"/></td>
                            <td v-if="sipNumberList(props.item).length > 0">
                                <ur-dropdown :class="dropdownClass(props.item.sipNumber)" style="width:240px" v-model="props.item.sipNumber" :items="sipNumberList(props.item)" :placeholder="$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_1')" @input="onDropdownSelected(props.item)" @click.native="onClickRow(props.item)" /> {{$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_2')}}
                            </td>
                            <td v-else>
                                <ur-dropdown :class="dropdownClass(props.item.sipNumber)" style="width:240px" v-model="tempValue" :items="[{text:'선택할 수 있는 번호가 없습니다.',}]" :placeholder="$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_1')" @click.native="onClickRow(props.item)" /> {{$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_2')}}
                            </td>
                            <td><aicc-stepper controlType='updown' v-model="props.item.channels" @input="onStepperChange" @change="onStepperChange" @click.native="onClickRow(props.item)" :min="1" :max="100" :validCheck="true" :rules="channelsRule"/> {{$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_3')}}</td>
                        </template>
                    </ur-table>
                </div>
                <div class="box_common">
                    <dl class="hbox">
                        <dt>{{$t('MSG_TXT_AICC_START_SIP_TOTAL_LABEL')}}</dt>
                        <dd>{{totalText}}</dd>
                    </dl>
                </div>
                <p :class="pClass">
                    {{$t('MSG_TXT_AICC_START_SIP_GUIDE_1')}}
                </p>
                <div class="btn_wrap">
                    <ur-button :text="$t('MSG_BTN_PREV')" large @click="onClickPrevious"/>
                    <ur-button :text="$t('MSG_BTN_FINISH')" large solid primary @click="onClickFinish" :disabled="!isValid"/>
                </div>
            </div>
        </section>
    </div>
<!--
    <div class="contents_wrap">
        <div class="login_wrap step2">
            <h3 class="call">{{this.$t('MSG_TXT_AICC_START_SIP_LABEL_1')}}</h3>
            <div class="box_gray">
                <div class="contents" style="width:80px;">
                    <div class="label" >{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_1')}}</div>
                    <div class="value">{{aiccInfo.contactCenterName}}</div>
                </div>
                <div class="divider"/>
                <div class="contents" style="width:290px;">
                    <div class="label">{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_2')}}</div>
                    <div class="value">{{contactCenterUrl}}</div>
                </div>
                <div class="divider"/>
                <div class="contents" >
                    <div class="label">{{this.$t('MSG_TXT_AICC_START_SIP_INFO_LABEL_3')}}</div>
                    <div class="value">{{aiccInfo.contactCenterPrice}}</div>
                </div>
            </div>
            <div class="tbl_info">
                <div class="total">
                    {{this.$t('MSG_TXT_AICC_START_SIP_TABLE_TOTAL')}}
                    <strong>{{items.length}}</strong>
                </div>
                <div class="btn_area">
                    <button :class="btnClass(false)" :disabled="items.length >= 100" @click="onClickRowAdd">{{this.$t('MSG_TXT_AICC_START_SIP_TABLE_ADD')}}</button>
                    <button :disabled="selected.length < 1" :class="btnClass(selected.length < 1)" @click="onClickRowDel">{{this.$t('MSG_TXT_AICC_START_SIP_TABLE_DEL')}}</button>
                </div>
            </div>
            <div class="tbl_list">
                <ur-table ref="table" multiSelect selectAll :headers="headers" :items="items" v-model="selected" noPage noControl @sort="onClickSort">
                    <template slot="items" slot-scope="props">
                        <td style="text-align: center;"><ur-checkbox small :checked="isRowSelected(props.item)" @click="onClickRow(props.item)"/></td>
                        <td v-if="sipNumberList(props.item).length > 0">
                            <ur-dropdown style="width:240px" noShake v-model="props.item.sipNumber" :items="sipNumberList(props.item)" :placeholder="$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_1')" @input="onDropdownSelected(props.item)" @click.native="onClickRow(props.item)" :rules="dropdownRule" message-style="light"/> {{$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_2')}}
                        </td>
                        <td v-else>
                            <ur-dropdown style="width:240px" noShake v-model="tempValue" :items="[{text:'선택할 수 있는 번호가 없습니다.',}]" :placeholder="$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_1')" @click.native="onClickRow(props.item)" :rules="noNumberDrondownRule" message-style="light"/> {{$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_2')}}
                        </td>
                        <td><aicc-stepper controlType='updown' v-model="props.item.channels" @input="onStepperChange" @click.native="onClickRow(props.item)" :min="1" :max="100"/> {{$t('MSG_TXT_AICC_START_SIP_TABLE_CELL_3')}}</td>
                    </template>
                </ur-table>
            </div>
            <div class="box_common">
                <dl class="hbox">
                    <dt>{{$t('MSG_TXT_AICC_START_SIP_TOTAL_LABEL')}}</dt>
                    <dd>{{totalText}}</dd>
                </dl>
            </div>
            <p :class="pClass">
                {{$t('MSG_TXT_AICC_START_SIP_GUIDE_1')}}
            </p>
            <div class="btn_wrap">
                <ur-button :text="$t('MSG_BTN_PREV')" large @click="onClickPrevious"/>
                <ur-button :text="$t('MSG_BTN_FINISH')" large solid primary @click="onClickFinish"/>
            </div>
        </div>
    </div>
-->
</template>
<script>
import urValidator from '@uidev/mixins/urValidator/urValidator.js';
export default {
    name:'PGE_AIM_00003',
    components:{
    },
    data() {
        return {
            aiccInfo:{
                contactCenterName:'',
                contactCenterUrl:'',
                contactCenterPrice:'',
            },

            sipNumberPool:[],
            selectedSipNumberList:[],
            selected:[],
            headers:[
                {text:this.$t('MSG_TXT_AICC_START_SIP_TABLE_HEADER_1'), sortable:true, value:'sipNumber',},
                {text:this.$t('MSG_TXT_AICC_START_SIP_TABLE_HEADER_2'), sortable:true, value:'channels'},
            ],
            items:[],
            isValid:true,
            dropdownRule:[
                v => v != null || '',
                v => v.sipNumber != null || '',
            ],
            noNumberDrondownRule:[
                v => false || '',
            ],
            channelsRule:[
                v => v != '' || '',
            ],
            totalNumberCount: 0,
            totalChannelsCount: 0,
            tempValue:null,
        }
    },
    created(){
    },
    mounted(){
        this.$store.commit('hideGnbMenu');
        this.getAICCInfo();
        this.getSipNumberList();
    },
    destroyed(){
    },
    watch:{},
    computed:{
        pClass(){
            let clazz = [];
            clazz.push('txt_desc');
            if(this.isValid === false) {
                clazz.push('error');
            } else {
                clazz.push('type2');
            }
            return clazz;
        },
        btnClass(){
            return(disabled) => {
                let clazz = ['btn', 'btn_border', 'btn_s'];
                if(disabled === true) {
                    clazz.push('btn_disabled');
                }
                return clazz;
            }
        },
        dropdownClass(){
            return (value) => {
                let clazz = [];
                if(!value) {
                    clazz.push('dropdown--error')
                }
                return clazz;
            }
        },
        contextPageId() {
            if (this._props._params && this._props._params.routerOriginPageId) {
                return this._props._params.routerOriginPageId;
            }
            if(this.$options.name.length > 13) {
                return this.$options.name.substr(0,13);
            }
            return this.$options.name;
        },
        contactCenterUrl(){
            let result;
            result = aiccUtils.urlUtil.getProtocolAndDomain() + '/home/' + this.aiccInfo.contactCenterUrl;
            return result;
        },
        sipNumberList(){
            return(item) => {
                const currentSipNumber = item.sipNumber;
                var result = [];
                for(let index in this.sipNumberPool) {
                    var tempItem = this.sipNumberPool[index];
                    if(this.selectedSipNumberList.indexOf(tempItem) < 0 || tempItem == currentSipNumber) {
                        result.push(tempItem);
                    }
                }
                return result;
            };
        },
        totalText(){
            let result;
            result = this.$t('MSG_TXT_AICC_START_SIP_TOTAL_FORMAT').replace('%(%S1)', this.totalNumberCount).replace('%(%S2)', this.totalChannelsCount);
            return result;
        },
        isRowAddDisabled(){
            let result = false;
            if(this.items && this.items.length >= 100) {
                result = true;
            }
            return result;
        },
    },
    methods:{
        onClickRowAdd(){
            this.items.push({sipNumber:null, oldSipNumber:null, channels:1,});
            this.$nextTick(() => {
                this.isDataValid();
            });
        },
        onClickRowDel(){
            while(this.selected.length > 0) {
                let tempItem = this.selected.pop();
                let tempItemIndex = this.items.indexOf(tempItem);
                if(tempItemIndex > -1) {
                    this.items.splice(tempItemIndex, 1);
                }

                let tempSipNumberIndex = this.selectedSipNumberList.indexOf(tempItem.sipNumber);
                if(tempSipNumberIndex > -1) {
                    this.selectedSipNumberList.splice(tempSipNumberIndex, 1);
                }
            }
            this.isDataValid();
        },
        onClickSort(header) {
            this.items.sort((x,y)=>{
                if( x[header.value] !== null && y[header.value] === null) {
                    return -1;
                }
                if( x[header.value] === null && y[header.value] !== null) {
                    return 1;
                }
                if( x[header.value] < y[header.value] ) return -1*(header.desc?1:-1);
                if( x[header.value] > y[header.value] ) return  1*(header.desc?1:-1);
                return 0;
            });
        },
        onClickRow(row){
            this.isDataValid();
            this.$refs['table'].onClickRow(row);
        },
        onDropdownSelected(item){
            if(this.selectedSipNumberList.indexOf(item.sipNumber) < 0) {
                this.selectedSipNumberList.push(item.sipNumber);
            }
            if(item.sipNumber != item.oldSipNumber) {
                const deleteIndex = this.selectedSipNumberList.indexOf(item.oldSipNumber);
                if(deleteIndex > -1) {
                    this.selectedSipNumberList.splice(deleteIndex, 1);
                }
                item.oldSipNumber = item.sipNumber;
            }
            this.$nextTick(() => {
                this.isDataValid();
            });
            
        },
        onStepperChange(input){
            this.isDataValid();
        },
        onClickPrevious(){
            this.changeAICCStatus('C');
        },
        onClickFinish(){
            if(urValidator.validateChildren(this.$refs['table']) === true && this.isDataValid() === true) {
               this.postNewSipNumber();
            }
        },
        getAICCInfo(){
            http.request(this.contextPageId, 'DTS_AIM_00001' , {})
                .then(res => {
                    this.aiccInfo.contactCenterName = res.data.aiccInfo.contactCenterNm;
                    this.aiccInfo.contactCenterUrl = res.data.aiccInfo.contactCenterUrl;
                    this.aiccInfo.contactCenterPrice = '스탠다드';
                })
                .catch(error => {

                })
        },
        getSipNumberList(){
            http.request(this.contextPageId, 'DTS_AIS_00003', {
                path: {
                    'type':'listUseable',
                }
            }).then(res => {
                this.sipNumberPool = [];
                for(let index in res.data.sipNumberList) {
                    let value = res.data.sipNumberList[index].sipNumber;
                    let temp = {
                        text:aiccUtils.phoneNumberFormat.format(value),
                        sipNumber:value,
                    };
                    this.sipNumberPool.push(temp);
                }
                this.onClickRowAdd();
            }).catch(error => {

            })
        },
        postNewSipNumber(){
            let sipNumberList = [];
                for(let index in this.items) {
                    sipNumberList.push({
                        sipNumber:this.items[index].sipNumber.sipNumber,
                        channels:this.items[index].channels,
                        statusCode:'B',
                    });
                }
                http.request(this.contextPageId, 'DTS_AIS_00004', {
                    data : {
                        srType:'A',
                        sipNumberList:sipNumberList,
                    }
                }).then(res => {
                    if(res.data.reply.code === '0000') {
                        this.changeAICCStatus('E');
                    } else {
                        utils.aiccMessageBox('확인', res.data.reply.korMsg, '확인', null, null, null);
                    }
                }).catch(error => {
                    console.warn(error)
                });
        },
        changeAICCStatus(statusCode){
            http.request(this.contextPageId, 'DTS_AIM_00007', {
                path : {
                    'status':statusCode
                }
            }).then(res => {
                if(res.data.reply.code === '0000') {
                    if(statusCode === 'C') {
                        utils.goPage('PGE_AIM_00002', null);
                    } else if(statusCode === 'E') {
                        this.$store.commit('setTenantStatus', 'E');
                        utils.goPage('PGE_AIM_00004', null);
                    }
                }
            })
        },
        isDataValid(){
            this.syncCount();
            let dataValid = (this.items.length > 0);
            for(let index in this.items) {
                if(!this.items[index].sipNumber || this.items[index].sipNumber == null || !this.items[index].sipNumber.sipNumber || this.items[index].sipNumber.sipNumber == null) {
                    dataValid = false;
                    break;
                }
            }
            if(dataValid === true && this.totalChannelsCount > 3 && this.totalChannelsCount < 101 && this.totalNumberCount > 0 && this.totalNumberCount < 101) {
                this.isValid = true;
                return true;
            }
            this.isValid = false;
            return false;
        },
        isRowSelected(row){
            let index = this.selected.indexOf(row);
            return index > -1;
        },
        syncCount(){
            this.totalNumberCount = 0;
            this.totalChannelsCount = 0;
            for(let index in this.items) {
                this.totalNumberCount++;
                let temp = parseInt(this.items[index].channels);
                if(isNaN(temp) != true) {
                    this.totalChannelsCount += parseInt(this.items[index].channels);
                }
            }
        },
    },
}
</script>
<style scoped>
    section {
        width: 100%;
    }
    .box_gray {
        margin: 0;
        margin-top: -1px;
    }
    .tbl_info {
        display: flex;
        margin-top: 24px;
        margin-bottom: 16px;
    }
    .tbl_info .total {
        font-size: 14px;
    }
    .tbl_info .total strong {
        color: #222;
        margin-left: 4px;
        font-weight: bold;
        font-size: 14px;
    }
    .tbl_info .total + .btn_area {
        margin-right: auto;
        position: relative;
        padding-left: 8px;
        margin-left: 8px;
    }
    .tbl_info .total + .btn_area::before {
        display: inline-block;
        content: '';
        width: 1px;
        height: 16px;
        background-color: #ddd;
        position: absolute;
        margin-top: 4px;
        left: 0;
    }
    .ur-button--small {
        height: 24px;
        min-width: 48px;
        font-size: 12px;
        padding: 0 8px;
    }
    /*
    .btn {
        display: inline-block;
        text-align: center;
        white-space: nowrap;
    }
    .btn + .btn {
        margin-left: 4px;
    }
    .btn_s {
        border-radius: 2px;
        min-width: 48px;
        height: 24px;
        line-height: 22px;
        padding: 0 8px;
        font-size: 12px;
        font-weight: 400;
    }
    .btn_border {
        border: 1px solid #8B9ABC;
        background-color: #FFF;
        color: #333;
    }
    .btn_disabled {
        border: 1px solid #ccc;
        color: #a5a5a5;
    }
    */
    .dropdown--error {
        border-color: #FF5858;
    }

    ::v-deep .ur-table > .ur-table__area > .ur-table__header > .ur-table__header__row > th > span {
        font-family: 'NotoSansCJKkr' !important;
        font-weight: 500;
    }
    ::v-deep .ur-dropdown.ur-input.ur-dropdown--medium.dropdown--error > .ur-dropdown__title.ur-dropdown__title-border {
        border-color: #FF5858;
    }
    .box_common {
        margin-top: 24px;
        padding: 14px 16px 13px;
        border-radius: 4px;
        background-color: #EFF1F8;
    }
    .hbox {
        display: flex;
        position: relative;
    }
    dt {
        font-weight: 500;
    }
    dd {
        margin-left: 20px;
        color: #2F2F38;
    }
    .txt_desc {
        margin-top: 8px;
        line-height: 20px;
    }
    .txt_desc .type2 {
        color: #222;
    }
    .txt_desc .error {
        color: #FF5858;
    }
    ::v-deep .ur-counter.ur-input.ur-counter--medium.ur-counter--center .ur-counter__input {
        height:100%
    }
    ::v-deep .ur-counter.ur-input.ur-counter--medium.ur-counter--center {
        width: 80px;
        background: #FFF;
    }
</style>
